export default "__VITE_ASSET__DezogUY6__"